export default __webpack_public_path__ + "static/media/logoMini.deed6094.svg";